let callbacks = []

const executeCallBacks = () => {
  callbacks.forEach((cb) => {
    cb();
  })
  callbacks = []
}
module.exports = {
  /* For now: default to cdn. */
  load(srcPath, callback) {
    srcPath = srcPath ? srcPath : dsf.url.getWebPath("$/js/libs");
    callbacks.push(callback)
    if (window.monaco) {
      executeCallBacks();
      return;
    }
    const config = {
      paths: {
        vs: srcPath + "/vs"
      },
      //中文版本
      "vs/nls": { availableLanguages: { "*": "zh-cn" } }
    };
    const loaderUrl = `${config.paths.vs}/loader.js`;
    const onGotAmdLoader = () => {
      if (window.LOADER_PENDING) {
        window.vs_require.config(config);
      }

      // Load monaco
      window.vs_require(["vs/editor/editor.main"], () => {
        executeCallBacks();
      });

      // Call the delayed callbacks when AMD loader has been loaded
      if (window.LOADER_PENDING) {
        window.LOADER_PENDING = false;
        const loaderCallbacks = window.LOADER_CALLBACKS;
        if (loaderCallbacks && loaderCallbacks.length) {
          let currentCallback = loaderCallbacks.shift();
          while (currentCallback) {
            currentCallback.fn.call(currentCallback.window);
            currentCallback = loaderCallbacks.shift();
          }
        }
      }
    };

    // Load AMD loader if necessary
    if (window.LOADER_PENDING) {
      // We need to avoid loading multiple loader.js when there are multiple editors loading concurrently
      //  delay to call callbacks except the first one
      window.LOADER_CALLBACKS = window.LOADER_CALLBACKS || [];
      window.LOADER_CALLBACKS.push({
        window: this,
        fn: onGotAmdLoader
      });
    } else {
      if (typeof window.require === "undefined") {
        const loaderScript = window.document.createElement("script");
        loaderScript.type = "text/javascript";
        loaderScript.src = loaderUrl;
        loaderScript.addEventListener("load", onGotAmdLoader);
        window.document.body.appendChild(loaderScript);
        window.LOADER_PENDING = true;
      } else {
        onGotAmdLoader();
      }
    }
  }
};
